export default __webpack_public_path__ + "static/The Home_Image 5_carousel 5@2x-f0e3aeaeae382d20b87e50954014db26.jpg";